var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _path11, _path12, _rect3, _path13, _rect4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriesHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 294,
    viewBox: "0 0 260 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3057 22.4102L70.5369 22.6446L69.2083 69.2885L60.977 69.054L62.3057 22.4102ZM70.344 29.5042L78.5752 29.7387L77.0903 81.8701L83.9489 82.0655L81.7617 158.85L74.9024 158.655L75.27 145.747L67.0396 145.512L70.344 29.5042Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8209 44.1623L38.3584 43.6934L37.6223 69.5357L45.8542 69.7702L44.4481 119.135L59.5388 119.564L60.9858 68.7637L54.1258 68.5683L54.8209 44.1623Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.325 6.84579L86.0938 6.61133L83.4552 99.242L91.6865 99.4765L94.325 6.84579ZM100.912 16.6443L94.0522 16.449L91.7663 96.7024L98.6257 96.8978L100.912 16.6443Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.811 23.9317L107.58 23.6973L104.835 120.055L113.067 120.289L115.811 23.9317ZM123.85 31.0256L115.619 30.7912L112.958 124.205L121.189 124.439L123.85 31.0256Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.078 25.2227L152.847 24.9883L150.268 115.532L158.499 115.767L161.078 25.2227ZM169.116 32.3157L160.885 32.0812L158.501 115.766L166.733 116L169.116 32.3157Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.836 32.7032L174.604 32.4688L171.465 142.694L179.696 142.928L182.836 32.7032ZM190.874 39.7971L182.643 39.5626L179.133 162.797L187.364 163.032L190.874 39.7971Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.951 6.74422L131.405 6.5293L128.551 106.751L136.096 106.966L138.951 6.74422ZM146.205 17.1866L138.66 16.9717L135.747 119.239L143.292 119.454L146.205 17.1866Z",
    fill: "#FFC700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.356 48.4219L197.497 48.2266L195 135.882L201.86 136.077L201.918 134.041L210.148 134.276L212.353 56.8883L204.122 56.6539L204.356 48.4219Z",
    fill: "#FFC700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.157 111.182L150.389 111.416L148.585 174.722L140.354 174.487L140.907 155.08L134.049 154.884L135.026 120.587L141.884 120.783L142.157 111.182Z",
    fill: "#FFC700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9981 83.8653L92.1387 83.6699L89.6368 171.505L96.4962 171.7L98.9981 83.8653ZM105.665 90.9192L98.8058 90.7238L96.4601 173.074L103.319 173.27L105.665 90.9192Z",
    fill: "#FFC700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.72,
    y: 106.166,
    width: 17.8417,
    height: 70.8849,
    transform: "rotate(1.63159 110.72 106.166)",
    fill: "#FFC700"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.499,
    y: 115.766,
    width: 13.7244,
    height: 57.5694,
    transform: "rotate(1.63159 158.499 115.766)",
    fill: "#FFC700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.682 10.2386L206.823 10.0432L206.159 33.3651L213.018 33.5605L213.682 10.2386ZM198.316 19.4141L206.547 19.6485L205.883 42.9705L197.651 42.736L197.925 33.1321L189.695 32.8977L189.89 26.0383L198.12 26.2727L198.316 19.4141Z",
    fill: "#FFC700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.493 11.8107L213.634 11.6153L213.008 33.5653L219.868 33.7607L220.493 11.8107ZM213.009 33.5674L206.15 33.372L205.916 41.6033L212.775 41.7987L213.009 33.5674Z",
    fill: "#E25B00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.35,
    y: 56.8906,
    width: 6.86218,
    height: 69.3686,
    transform: "rotate(1.63159 212.35 56.8906)",
    fill: "#E25B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2832 8.2168L101.143 8.41218L100.908 16.6435L94.0487 16.4481L94.2832 8.2168ZM92.3299 76.8092L99.1882 77.0045L100.908 16.6441L107.767 16.8395L105.657 90.9209L98.7973 90.7255L98.9928 83.8639L92.1345 83.6686L92.3299 76.8092ZM113.892 91.1553L105.66 90.9209L103.395 170.461L111.626 170.696L113.462 106.247L121.691 106.481L121.886 99.6218L113.657 99.3874L113.892 91.1553ZM123.606 39.2584L130.465 39.4538L128.55 106.676L121.691 106.48L123.606 39.2584Z",
    fill: "#E25B00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150.269,
    y: 115.531,
    width: 8.23461,
    height: 64.9511,
    transform: "rotate(1.63159 150.269 115.531)",
    fill: "#E25B00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.833 32.707L191.064 32.9415L190.869 39.8009L182.638 39.5664L182.833 32.707ZM197.651 42.7392L204.508 42.9345L204.351 48.4221L197.495 48.2268L195.072 133.286L188.212 133.09L191.065 32.9433L197.924 33.1387L197.651 42.7392Z",
    fill: "#E25B00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.598 32.4747L169.11 32.3184L166.727 116.003L172.214 116.159L174.598 32.4747ZM180.444 116.395L172.213 116.161L171.119 154.573L179.35 154.808L180.444 116.395Z",
    fill: "#E25B00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.185 9.47084L146.416 9.70531L146.182 17.9366L137.951 17.7021L138.185 9.47084ZM146.183 17.9372L153.042 18.1326L150.385 111.42L143.525 111.225L146.183 17.9372ZM143.639 107.107L128.549 106.677L126.47 179.644L141.561 180.074L143.639 107.107Z",
    fill: "#E25B00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5342 22.6426L78.7655 22.877L78.5701 29.7364L70.3388 29.502L70.5342 22.6426ZM78.5727 29.7355L85.4321 29.9309L83.908 83.4342L77.0487 83.2388L78.5727 29.7355ZM92.1334 83.6712L83.9022 83.4367L82.3782 136.94L90.6094 137.174L92.1334 83.6712Z",
    fill: "#E25B00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1523 37.1094L55.0117 37.3048L54.8164 44.1642L47.957 43.9688L48.1523 37.1094ZM54.8176 44.1633L61.677 44.3587L60.9736 69.0525L54.1142 68.8571L54.8176 44.1633ZM69.2025 69.288L60.9712 69.0536L58.8653 142.987L67.0965 143.221L69.2025 69.288Z",
    fill: "#E25B00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6875 99.9082L52.692 97.942L53.4908 106.475L61.3675 105.738L62.0434 112.958L68.6073 112.344L69.2217 118.908L77.0984 118.17L77.7128 124.734L84.2768 124.12L85.0141 131.996L99.4547 130.645L100.131 137.865L114.571 136.513L115.37 145.046L150.815 141.728L149.955 132.539L164.395 131.187L163.781 124.623L178.222 123.271L177.484 115.395L185.361 114.657L184.747 108.093L191.31 107.479L190.696 100.915L198.573 100.178L197.835 92.3011L204.399 91.6866L203.662 83.8099L224.666 81.8437L231.425 154.047L38.4463 172.111L31.6875 99.9082Z",
    fill: "#DC4200"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6975 171.62L226.174 154.538L230.967 205.737L48.4901 222.818L43.6975 171.62Z",
    fill: "#DC4200"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9923 221.835L220.465 206.72L225.503 260.544L64.0307 275.659L58.9923 221.835Z",
    fill: "#DC4200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0307 275.659L111.291 271.235L112.151 280.425L106.9 280.916L107.76 290.106L71.0023 293.547L70.1421 284.357L64.8909 284.849L64.0307 275.659Z",
    fill: "#DC4200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.243 264.968L225.503 260.544L226.363 269.733L221.112 270.225L221.972 279.414L185.214 282.855L184.354 273.666L179.103 274.157L178.243 264.968Z",
    fill: "#DC4200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M186.244 4.84911L176.546 6.24434L179.075 23.8223L188.773 22.4271L186.244 4.84911Z",
    fill: "#FFC700"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M176.546 6.24434L171.697 6.94195L174.226 24.52L179.075 23.8223L176.546 6.24434Z",
    fill: "#E25B00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.547 0L175.849 1.39523L176.546 6.24434L186.244 4.84911L185.547 0Z",
    fill: "#E25B00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.924 23.1247L179.075 23.8223L179.773 28.6714L184.622 27.9738L183.924 23.1247Z",
    fill: "#E25B00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32411 85.2262L12.278 83.3629L7.87999 66.9495L0.926151 68.8128L5.32411 85.2262Z",
    fill: "#FFC700"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72692 87.75L13.2038 86.8184L6.9541 63.494L3.47718 64.4257L9.72692 87.75Z",
    fill: "#FFC700"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80103 84.2945L9.72692 87.75L22.7654 84.2564L21.8395 80.8009L8.80103 84.2945Z",
    fill: "#FFC700"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4367 78.2771L18.3626 81.7325L25.3164 79.8693L24.3905 76.4138L17.4367 78.2771Z",
    fill: "#FFC700"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9646 65.3191L14.8905 68.7746L21.8443 66.9113L20.9184 63.4559L13.9646 65.3191Z",
    fill: "#FFC700"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47718 64.4257L4.40307 67.8811L17.4415 64.3875L16.5156 60.932L3.47718 64.4257Z",
    fill: "#FFC700"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M224.902 44.3314L233.016 49.1176L244.313 29.9662L236.199 25.1799L224.902 44.3314Z",
    fill: "#FFC700"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M226.58 50.7564L230.637 53.1495L246.691 25.9343L242.634 23.5411L226.58 50.7564Z",
    fill: "#FFC700"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M228.959 46.7245L226.58 50.7564L241.794 59.7306L244.172 55.6987L228.959 46.7245Z",
    fill: "#FFC700"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M242.494 49.2737L240.115 53.3056L248.229 58.0918L250.607 54.0599L242.494 49.2737Z",
    fill: "#FFC700"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M251.412 34.1541L249.034 38.186L257.148 42.9722L259.526 38.9403L251.412 34.1541Z",
    fill: "#FFC700"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M242.634 23.5411L240.256 27.573L255.469 36.5472L257.848 32.5153L242.634 23.5411Z",
    fill: "#FFC700"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0247 110.769L19.0515 108.26L13.1291 101.116L10.1023 103.625L16.0247 110.769Z",
    fill: "#FFC700"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7849 111.019L20.2983 109.764L11.8823 99.6119L10.3689 100.866L18.7849 111.019Z",
    fill: "#FFC700"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5381 109.515L18.7849 111.019L24.4601 106.314L23.2133 104.81L17.5381 109.515Z",
    fill: "#FFC700"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4531 104.561L21.6999 106.065L24.7267 103.556L23.4799 102.052L20.4531 104.561Z",
    fill: "#FFC700"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7775 98.9205L17.0244 100.425L20.0511 97.9155L18.8043 96.4114L15.7775 98.9205Z",
    fill: "#FFC700"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3689 100.866L11.6157 102.371L17.2909 97.666L16.0441 96.1619L10.3689 100.866Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriesHover);
export default __webpack_public_path__ + "static/media/fries_hover.9a19c77918383c9a389c59cf51eea280.svg";
export { ForwardRef as ReactComponent };